import { Link } from 'react-router-dom';
import { categories } from '@/mocks/photography';

export default function ServiceCards() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            摄影风格分类
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            多元风格选择，满足你对写真的所有想象
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?type=${cat.id}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              data-product-shop
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.coverImage}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-white text-lg font-heading">
                  {cat.name}
                </h3>
              </div>
              <div className="p-4">
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  <span>查看作品</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}